import { useEffect } from "react"

interface UseEscapeKeyOptions {
  isEnabled?: boolean
  onEscape: () => void
}

/**
 * Hook that handles escape key press events
 * @param options.isEnabled - Whether the escape key handler is enabled
 * @param options.onEscape - Callback function to execute when escape key is pressed
 */
export const useEscapeKey = ({ isEnabled = true, onEscape }: UseEscapeKeyOptions): void => {
  useEffect(() => {
    if (!isEnabled) return

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onEscape()
      }
    }

    window.addEventListener("keydown", handleKeyDown)

    return () => {
      window.removeEventListener("keydown", handleKeyDown)
    }
  }, [isEnabled, onEscape])
}
